import AppLink from '@/components/common/AppLink';
import styles from './styles.module.css';
import { blogBg, brandBg } from '@/functions/formats';

import MainIcons from '@/icons/main';
import RateComponent from '@/components/common/RateComponent';
import { useEffect, useState } from 'react';
import { useLayoutContext } from '@/context/LayoutContext';
import { productCardType } from '@/commonTypes';
import ProductBadges from './ProductBadges';
import AddToCartButton from './AddToCartButton';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import IncreaseDecreaseButtons from './IncreaseDecreaseButtons';
import Button from '@/components/common/Button';

type Props = {
  item: productCardType; // Replace with your new product
  index: number;
  onAdd?: (item: any) => void;
  callbackFavorite?: (x: productCardType) => void;
  showBageds?: boolean;
  showButton?: boolean;
  direction?: 'vertical' | 'horizontal';
  showCount?: boolean;
  showRemove?: boolean;
  showCartButtons?: boolean;
  count?: number | string;
  showDelete?: boolean;
  movingCard?: boolean;
  showRate?: boolean;
  showDistance?: boolean;
  showInBasket?: boolean;
  showShop?: boolean;
  inBasket?: boolean;
};

export default function ProductCard({
  item,
  index,
  onAdd,
  callbackFavorite,
  showBageds = true,
  showButton = true,
  direction = 'vertical',
  showRemove = false,
  showCartButtons,
  count,
  showDelete = false,
  movingCard = true,
  showRate = false,
  showDistance = true,
  showInBasket = false,
  showShop = true,
  inBasket = false,
}: Props) {
  const [data, setData] = useState<productCardType>(item);

  const { checkIfLogin, callBackFav, priceSymbol, loadingDeleteCartItem, deleteFromBasket } =
    useLayoutContext();

  useEffect(() => {
    setData(item);
  }, [item]);
  const favFunction = (x: productCardType) => {
    // setData({ ...x, isLiked: !x?.isLiked });
    // callbackFav && callbackFav(x);
    checkIfLogin && setData && checkIfLogin(() => callBackFav(x, data, setData, callbackFavorite));
  };
  return (
    <article
      className={`${styles.card} ${direction == 'horizontal' && styles.horizontalCard} ${movingCard && 'movingCard'} ${inBasket && styles.inBasket}`}
    >
      <AppLink
        href={`/products/${data?.slug}`}
        className={`${styles.imageWrapper} ${direction == 'horizontal' && styles.imageWrapperHorizontal} ${showInBasket && styles.inbasketImage}`}
        style={{ background: brandBg(index) }}
      >
        <div className={styles.pattern} />

        {
          data?.image && (
            <img src={data?.image?.src} alt={data?.image?.alt} className={styles.image} />
          )
          // : (
          //   <span className={styles.category}>{data?.subtitle}</span>
          // )
        }

        {showBageds && <ProductBadges data={data} />}

        {/* <button
          type="button"
          className={styles.likeButton}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            favFunction(item);
          }}
        >
          <MainIcons.hearthIcon fill={data?.isLiked ? 'var(--accent)' : 'var(--text-mut)'} />
        </button> */}
      </AppLink>

      <div className={styles.content}>
        {showShop && (
          <div className={styles.shopRow}>
            <div className={styles.shop}>
              <MainIcons.shopIcon fill="var(--text-mut)" width="13px" height="13px" />
              {data?.shop?.title}
            </div>

            {showRate && (
              <span className={styles.rating}>
                <RateComponent
                  number={1}
                  className={`w-auto`}
                  rate={Number(data?.rating)}
                  activeFillColor="var(--accent-red)"
                />
                {data?.rating}
              </span>
            )}
          </div>
        )}

        <AppLink
          href={`/products/${data?.slug}`}
          className={`${styles.title} ${direction == 'horizontal' && styles.titleHorizontal}`}
        >
          {data?.title}
        </AppLink>

        {showDistance && (
          <div className={styles.meta}>
            <span>
              <MainIcons.locationIcon width="14px" height="14px" fill="var(--text-mut)" />
              {data?.distance}
            </span>

            {data?.shipping?.fast && (
              <span className={styles.shipping}>
                <MainIcons.truckIcon fill="var(--green)" width="14px" height="14px" />
                {data?.shipping?.text}
              </span>
            )}
          </div>
        )}

        <div className={styles.footer}>
          {(showCartButtons || showRemove) && (
            <div className={`${styles.cartButtonsContainer}`}>
              <div className={`${styles.buttonsContainer}`}>
                {showCartButtons && (
                  <IncreaseDecreaseButtons
                    item={data}
                    count={Number(count)}
                    className={`${styles.increaseDecrease}`}
                  />
                )}
                {showRemove && (
                  <>
                    <Button
                      className={`${styles.removeButton} link-btn link-a`}
                      loading={loadingDeleteCartItem == item?.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        deleteFromBasket && deleteFromBasket(data);
                      }}
                    >
                      <MainIcons.deleteIcon fill="var(--text-mut)" width={'15px'} height={'15px'} />
                      حذف
                    </Button>
                  </>
                )}
              </div>
            </div>
          )}
          <div>
            {data?.discount?.price && (
              <div className={styles.oldPrice}>{data?.price?.toLocaleString('fa-IR')}</div>
            )}

            <PriceSection
              className={`${styles.price}`}
              value={data?.discount?.price ? data?.discount?.price : data?.price}
            />
          </div>

          {showButton && <AddToCartButton item={data} />}
        </div>
      </div>
    </article>
  );
}
